import { faPencil, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { VMBuilder } from "../../commons/base/providers/builder";
import SoldOutCmsEditorViewModel, { CaseType } from "../view_models/sold_out_cms_editor_view_model";

interface Props {
    caseType: CaseType
}

export default class SoldOutCmsTableWidget extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <VMBuilder<SoldOutCmsEditorViewModel>>
                {(vm) => (
                    <div className="overflow-x-auto">
                        <table className="table-fixed min-w-full border-collapse text-center">
                            <thead>
                                <tr className="bg-gray-200">
                                    <th className="p-1.5 border border-gray-300 w-1/3">
                                        Name
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-1/3">
                                        Type
                                    </th>
                                    <th className="p-1.5 border border-gray-300 w-1/3">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {vm.filteredItemToAffectedMenus(this.props.caseType).map(
                                    (model, index) => (
                                        <tr
                                            key={index}
                                            className="bg-white text-center hover:bg-slate-200"
                                        >
                                            <td className="p-3 border border-gray-300">
                                                {model.name}
                                            </td>
                                            <td className="p-3 border border-gray-300">
                                                {model.type}
                                            </td>
                                            <td className="p-3 border border-gray-300">
                                                <button
                                                    className="mx-1 px-3 py-1 rounded-md bg-purple-500 hover:bg-purple-700"
                                                    onClick={() =>
                                                        vm.openModalForUpdate(
                                                            model.id,
                                                            this.props.caseType
                                                        )
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        className="text-white"
                                                        icon={faPencil}
                                                    />
                                                </button>
                                                <button
                                                    className="mx-1 px-3 py-1 rounded-md bg-red-500 hover:bg-red-700"
                                                    onClick={() => {
                                                        vm.openModalForDelete(model.id, this.props.caseType);
                                                    }}>
                                                        <FontAwesomeIcon 
                                                            className="text-white"
                                                            icon={faX}
                                                        />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
